import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { SelectArrowMid } from '@zooplus/icons';
import { Anchor } from '@zooplus/ui-components';
import CreditCardNew from '../../../components/CreditCardNew/CreditCardNew.js';
import useIsMobile from '../../../hooks/useIsMobile.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { useCreditCardContext } from '../../../providers/CreditCardContextProvider.js';
import { Sizes } from '../../../types-internal/index.js';
import { range } from '../../../utils/utils.js';
import styles from './SavedCreditCards.module.scss.js';

const SavedCreditCards = () => {
    const { t } = useTranslation();
    const [seeMore, setSeeMore] = useState(true);
    const toggleShowMore = () => setSeeMore((sM) => !sM);
    const { deleteCreditCard, selectCreditCard, creditCardsList, status, selectedCardIdentifier } = useCreditCardContext();
    const cards = creditCardsList?.flatMap((cardInfo) => (cardInfo.cards || []).map((card) => ({
        ...card,
        paymentMethod: cardInfo.paymentMethod,
    })));
    const creditCardsLength = cards?.length || 0;
    const isMobile = useIsMobile(Sizes.SM);
    const defaultVisibleCardNo = isMobile ? 2 : 3;
    const visibleCardsNo = range(seeMore ? defaultVisibleCardNo : creditCardsLength);
    if (creditCardsLength <= 0)
        return null;
    return (jsxs("div", { className: styles.creditCardsContainer, children: [jsx("div", { className: styles.creditCardsWrapper, children: visibleCardsNo.map((idx) => {
                    const creditCard = cards?.[idx];
                    if (!creditCard)
                        return null;
                    return (jsx(CreditCardNew, { creditCard: {
                            ...creditCard,
                            selected: selectedCardIdentifier === creditCard?.pspIdentifier,
                        }, onDelete: deleteCreditCard?.(creditCard), onSelect: selectCreditCard?.(creditCard), showIcons: true, status: status }, creditCard?.pspIdentifier));
                }) }), creditCardsLength > defaultVisibleCardNo && (jsxs(Anchor, { className: styles.seeMore, onClick: toggleShowMore, children: [seeMore
                        ? t('checkout.payment.creditcard.seeMore')
                        : t('checkout.payment.creditcard.seeLess'), "\u00A0", jsx(SelectArrowMid, {})] }))] }));
};

export { SavedCreditCards as default };
//# sourceMappingURL=SavedCreditCards.js.map
